<template>
  <div class="result-patient-list">
    <div class="result-patient-header" v-if="results.length >= perPage">
      <div v-if="numberOfArrythmicCases" class="null-attributes-container">
        <div class="alert-icon"></div>
        <div class="alert-text">
          <div><b>{{numberOfArrythmicCases}} Arrythmic </b>
            <b v-if="numberOfArrythmicCases > 1">Cases</b>
            <b v-else>Case</b></div>
          <div>The mean and standard deviation shown for each subject are computed from its non-arrythmic cases.</div>
        </div>
      </div>
      <div class="pagination">
        <pagination v-model="currentPage" :records="results.length" :per-page="perPage"></pagination>
      </div>
    </div>
    <div class="patient-list">
      <result-patients-list-item
        v-for="patient in paginatedResults"
        :patient="patient"
        :key="patient.id"
        :expanded="expanded.indexOf(patient)>=0"
        @expand="()=>toggleExpanded(patient)"
        :selected="selection && (selection.findIndex((p)=>p.subject.id===patient.subject.id)>=0)"
        @selectToggle="toggleSelected"
        :selectedChildren="patient.cases && selection && (patient.cases.filter((c)=>selection.findIndex((cc)=>cc.subject.id===c.subject.id)>=0))"
      ></result-patients-list-item>
    </div>
    <!-- <result-patients-panel class="floating-panel" :caseList="flatResults" :selectionList="selected"></result-patients-panel> -->
  </div>
</template>

<script>
import ResultPatientsListItem from '@/components/ResultPatientsListItem'
import Pagination from 'vue-pagination-2';
import ResultPatientsPanel from '@/components/ResultPatientsPanel'

export default {
  name: 'ResultPatientList',
  props: ['results','selection'],
  components: { ResultPatientsListItem, Pagination, ResultPatientsPanel},
  data () {
    return {
      currentPage: 1,
      perPage: 20,
      expanded: [],
   
    }
  },
  computed: {
    paginatedResults () {
      return this.results.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage)
    },
    flatResults () {
      return this.results.map(e => e.cases).flat()
    },
    numberOfArrythmicCases () {
      let allCases = this.results.map(res => res.cases).flat()
      let arrythmicCases = allCases.filter(c => c.scalars.some(s => s.value == null))
      return arrythmicCases.length
    }
  },
  methods: {
    toggleExpanded (item) {
      if(this.expanded.indexOf(item)>=0) {
        this.expanded.splice(this.expanded.indexOf(item),1)
      } else {
        this.expanded.push(item)
      }
    },
    toggleSelected (items, value) {
      let currentSelection = this.selection || []
      let toggle = (item)=>{
        let is,should
        if(currentSelection.indexOf(item)>=0) is = true
        else is = false

        if(value===true) should = true
        else if(value===false) should = false
        else should = !is


        if(should && !is) currentSelection.push(item)
        else if(!should && is) currentSelection.splice(currentSelection.indexOf(item),1)

        this.$emit('select',currentSelection.length>0?currentSelection:null)
      }
      if(Array.isArray(items)){
        items.forEach((item)=>toggle(item,value))
      } else {
        toggle(items)
      }
      
    }
  },
  watch: {
    results () {
      this.currentPage = 1
    }
  }
}
</script>

<style lang="stylus" scoped>
.result-patient-list
  display: flex
  flex-direction: column

  // margin-top 15px
  // padding-bottom 80px // no puede ser "aqui", me lo llevo a ExectuionResultsView
  // max-height: calc(100vh - 120px) // TODO: Fix esto, sin esto no hace el scroll
  .result-patient-header
    align-items: center
    display: flex
    flex: 0 0 $header-height
    // flex: 0 0 auto
    // flex-direction: row
    padding: 0 10px

    .null-attributes-container
      background-color: rgba(255,0,0,0.1)
      display: flex
      margin-top: 5px
      margin-bottom: 5px
      padding: 10px
      m-font-size(12, 14)
      color: $shuttle-gray
      align-items: center

      .alert-icon
        m-icon("alert", 18)
        cursor: pointer
        margin-right: 10px

    .button-filter
      margin-right: 15px

    .pagination
      margin-left: auto

  .patient-list
    flex: 1 1 0%
    overflow-y: auto
    // margin-bottom 60px
</style>

<style lang="stylus">
.VuePagination
  text-align: right

  .pagination
    align-items: center
    display: flex

  .page-item
    // display: inline
    &:not(:last-child)
      margin-right: 10px

    &.active
      font-weight: $fw-bold

    a
      color: $cloud-burst
      // opacity: 0.75
      text-decoration: none

      &:hover
        // opacity: 1
        text-decoration: underline

      &.active
        color: $radical-red
        font-weight: normal
        // opacity: 1

  .VuePagination__pagination-item
    &.disabled
      opacity: 0.2
      pointer-events: none

  .VuePagination__pagination-item-prev-page,
  .VuePagination__pagination-item-next-page
    > a
      display: block
      m-font-size(0)
      m-icon("arrow-pagination-single", 10)

  .VuePagination__pagination-item-prev-page
    > a
      transform: rotate(-180deg)

  .VuePagination__pagination-item-prev-chunk,
  .VuePagination__pagination-item-next-chunk
    > a
      display: none
      m-font-size(0)
      m-icon("arrow-pagination-double", 10)

  .VuePagination__pagination-item-prev-chunk
    > a
      transform: rotate(-180deg)

  // No esta esto en el disenyo, pero lo pone "automaticamente" el vue pagination...
  .VuePagination__count
    display: none
</style>